import React from 'react';
import PropTypes from 'prop-types';

const CrossCircleIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
      fill={color}
    />
    <path
      d="M10.6663 5.33325L5.33301 10.6666M10.6663 10.6666L5.33301 5.33325"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
    />
  </svg>
);

CrossCircleIcon.propTypes = {
  color: PropTypes.string,
};

export default CrossCircleIcon;
